export default __webpack_public_path__ + "static/media/hbs-k-blk-3.f868b65c.png";